import { get } from 'lodash';
import { createAction } from 'redux-actions';
import { CALL_API } from '../constants';

const getErrorText = error => Promise.reject(get(error, ['body', 'error']));

const UserService = {
  changePassword: createAction(CALL_API, (id, payload) => ({
    body: payload,
    method: 'PUT',
    path: `/users/${id}/password`,
    handleError: getErrorText,
  })),

  forgotPassword: createAction(CALL_API, payload => ({
    body: payload,
    method: 'POST',
    path: '/auth/forgotpassword',
    handleError: getErrorText,
  })),

  resetPassword: createAction(CALL_API, payload => ({
    body: payload,
    method: 'PUT',
    path: '/auth/resetpassword',
    handleError: getErrorText,
  })),

  create: createAction(CALL_API, user => ({
    body: user,
    method: 'POST',
    path: '/auth/register',
    handleError: getErrorText,
  })),

  getAll: createAction(CALL_API, () => ({
    method: 'GET',
    path: '/users',
  })),

  update: createAction(CALL_API, (id, user) => ({
    body: user,
    method: 'PUT',
    path: `/users/${id}`,
  })),

  delete: createAction(CALL_API, id => ({
    method: 'DELETE',
    path: `/users/${id}`,
  })),
};

export default UserService;



// WEBPACK FOOTER //
// ./src/lib/dataLayer/user/UserService.js